export { GeneVariantsTable } from './GeneVariantsTable.component';
